module.exports = __webpack_public_path__ + "static/media/Varun Taneja.c30a583d.jpg";